import {createRandomAlphaNum, hash256Hex} from "./AppUtils.ts";
import {sessionAPI} from "./TR3AD.ts";
import {Session} from "./sdo/Session.ts";
import {SessionNetwork} from "./sdo/SessionNetwork.ts";

export default class AppSession
{
    protected username: string | null;
    protected loggedIn: boolean;
    protected initialized: boolean = false;

    private sessionKey: string | null;
    private sessionToken: string | null;
    private sessionExpiresAt: number | null;
    private sessionStartedAt: number | null;

    private connectedNetwork: SessionNetwork | null;

    constructor()
    {
        console.log("AppSession::constructor");

        this.username = window.localStorage.getItem("username");

        //TODO: Set to FALSE to enable session controls
        this.loggedIn = true;

        this.sessionKey = null;
        this.sessionToken = null;
        this.sessionExpiresAt = null;
        this.sessionStartedAt = null;
        this.connectedNetwork = null;
    }

    getConnectedNetwork():SessionNetwork|null
    {
        return this.connectedNetwork;
    }

    getUsername():string|null
    {
        return this.username;
    }

    activeSession():boolean
    {
        //TODO: Remove to enable session controls
        return true;

        // if (this.loggedIn)
        // {
        //     return (this.connectedNetwork !== null);
        // }
        // if (this.initialized === false)
        // {
        //     return this.loadLast();
        // }
        // return false;
    }

    login(username: string, password: string, callback: (a:boolean, msg:string) => void): void
    {
        console.info(this.loggedIn);
        if (this.loggedIn)
        {
            callback(this.loggedIn,"Already logged in");
            return;
        }

        if (username !== undefined && password !== undefined)
        {
            sessionAPI.start(username, password).then((response) => {
                if (response.status === 200)
                {
                    const sessionResults:Session = response.data as Session;

                    this.username = username;
                    window.localStorage.setItem("username", this.username);

                    this.loggedIn = true;
                    this.initialized = true;

                    this.sessionKey = sessionResults.key;
                    this.sessionToken = sessionResults.token;
                    this.sessionStartedAt = sessionResults.startedAt;
                    this.sessionExpiresAt = sessionResults.expiresAt;
                    this.connectedNetwork = null;

                    window.localStorage.setItem("sessionKey", this.sessionKey);
                    window.localStorage.setItem("sessionToken", this.sessionToken);
                    window.localStorage.setItem("sessionStartedAt", String(this.sessionStartedAt));
                    window.localStorage.setItem("sessionExpiresAt", String(this.sessionExpiresAt))
                    window.localStorage.removeItem("sessionNetworkKey")
                    window.localStorage.removeItem("sessionNetworkName")

                    // console.log("AppSession::loggedIn::" + this.loggedIn + "::" + this.username + "::" + this.sessionKey);

                    callback(this.loggedIn, "Successfully logged in");
                }
            }).catch((error) => {
                const errorMessage:string = error.response.data.error;
                callback(false, errorMessage);
            })
        }
    }

    connect(network:SessionNetwork, callback: (a:boolean) => void):void
    {
        //TODO: Remove to enable session controls
        this.connectedNetwork = network;
        callback(true);

        // sessionAPI.connectToNetwork(network).then((response) => {
        //     if (response.status === 200)
        //     {
        //         this.connectedNetwork = network;
        //
        //         window.localStorage.setItem("sessionNetworkKey", this.connectedNetwork.key);
        //         window.localStorage.setItem("sessionNetworkName", this.connectedNetwork.name);
        //
        //         callback(true);
        //     }
        //     else
        //     {
        //         callback(false);
        //     }
        // }).catch((error) => {
        //     console.log(error);
        // })
    }

    logout(callback: (a:boolean) => void): void
    {
        sessionAPI.end().then(response => {
            if (response.status === 200)
            {
                this.clearSession();

                callback(!this.loggedIn);
            }
            else
            {
                console.log("Error logging out");
            }
        }).catch((error) => {
            console.info(error);
        })
    }

    getNetworks(callback: (a:boolean, networks:SessionNetwork[], message:string) => void):void
    {
        callback(true, [{
            key: "dev",
            name: "Development Network"
        }], "");

        // sessionAPI.getNetworks().then((response) => {
        //     if (response.status === 200)
        //     {
        //         callback(true, response.data as SessionNetwork[], "");
        //     }
        //     else
        //     {
        //         callback(false, [], "Error getting networks");
        //     }
        // }).catch((error) => {
        //     callback(false, [], error.message);
        // })
    }

    loadLast():boolean
    {
        this.initialized = true;

        this.sessionKey = window.localStorage.getItem("sessionKey");
        this.sessionToken = window.localStorage.getItem("sessionToken");
        this.sessionStartedAt = Number(window.localStorage.getItem("sessionStartedAt"));
        this.sessionExpiresAt = Number(window.localStorage.getItem("sessionExpiresAt"));

        // console.log("AppSession::loadLast::" + this.sessionKey + "::" + this.sessionToken + "::" + this.sessionStartedAt + "::" + this.sessionStartedAt + ":" + this.sessionExpiresAt);

        if (this.sessionKey !== null && this.sessionToken !== null && this.sessionExpiresAt !== null)
        {
            if (Date.now() < this.sessionExpiresAt)
            {
                const sessionNetworkKey:string = String(window.localStorage.getItem("sessionNetworkKey"));
                const sessionNetworkName:string = String(window.localStorage.getItem("sessionNetworkName"));

                if (sessionNetworkKey && sessionNetworkName)
                {
                    this.connectedNetwork = {
                        key: sessionNetworkKey,
                        name: sessionNetworkName,
                    }

                    this.loggedIn = true;

                    return true;
                }
            }
        }

        this.clearSession();

        return false;
    }

    clearSession():void
    {
        console.log("AppSession::clearSession");

        this.loggedIn = false;
        this.sessionKey = null;
        this.sessionToken = null;
        this.sessionExpiresAt = null;
        this.sessionStartedAt = null;
        this.connectedNetwork = null;

        window.localStorage.removeItem("sessionKey");
        window.localStorage.removeItem("sessionToken");
        window.localStorage.removeItem("sessionExpiresAt");
        window.localStorage.removeItem("sessionStartedAt");
        window.localStorage.removeItem("sessionNetworkKey");
        window.localStorage.removeItem("sessionNetworkName");
    }

    createRequestHeader(includeSAH:boolean = true)
    {
        if (includeSAH === false)
        {
            return {
                headers: {
                    "x-api-key": import.meta.env.VITE_API_KEY
                }
            }
        }

        //Create a random seed value
        const seed = createRandomAlphaNum(12);

        //Add the random seed to the session token
        const content:string = seed + this.sessionToken;
        //Calculate the hash token
        const hashToken:string = hash256Hex(content);

        //Build the SAH code
        const sahCode:string = "WEB-" + this.sessionKey + "-" + seed + "-" + hashToken;

        return  {
            headers: {
                "x-api-key": import.meta.env.VITE_API_KEY,
                "x-auth-sah": sahCode
            }
        }
    }
}